import { render, staticRenderFns } from "./SquareCheckbox.vue?vue&type=template&id=3bfd6bd4&scoped=true"
import script from "./SquareCheckbox.vue?vue&type=script&lang=js"
export * from "./SquareCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SquareCheckbox.vue?vue&type=style&index=0&id=3bfd6bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfd6bd4",
  null
  
)

export default component.exports